import React from 'react';
import { EducationCardComponent } from './educationCard';

export const EducationCard = ({education})=> {
    return (
     <section>
          <h2 class="text-secondary fw-bolder mb-4">Education</h2>
          {education?.map(({school,degree,graduated,description,location},i)=>(
            <EducationCardComponent 
                key={i}
                duration={graduated}
                school={school}
                location={location}
                qualification={degree}
                description={description}
            />
         ))}
     </section>
    )
}